import React, { useState, useEffect } from "react";
import { ProposalWithTotals } from "./ProposalWithTotals.jsx";

export function TrendingProposalsWidget({configuration}) {
    const [proposals, setProposals] = useState([]);
    const [name, setName] = useState('')

    useEffect(() => {
      getProposalSet();
    }, []);

    const headers = {
        "Accept-Language": window.location.pathname.split("/")[1],
    }

    const getProposalSet = async () => {
        fetch(`/api/v1/proposals/${configuration.proposalsetId}/get_trending_proposals/`, {headers: headers})
            .then(response => response.json())
            .then(data => {
                setName(data.name);
                setProposals(data.proposal_set);
            });
    };

    let out;
    if (proposals.length > 0) {
        out = (
          <div className="card p-3">
            <h4 className="card-title d-flex align-items-center gap-2">
                <i className="fa-regular fa-star"></i>
                {configuration.translations.title}
            </h4>
            <div id="trending-proposals-widget" className="card-body">
                {proposals.map(proposal =>
                    <ProposalWithTotals
                        key={proposal.pk}
                        name={name}
                        proposal={proposal}
                        configuration={configuration}
                    />
                )}
            </div>
          </div>
        );
    } else {
        out = "";
    }

    return out;
}
